import api from '@/api/index.js'

const account_purchase = {
  state: {
    loading: false,
    data: null,
    error: null,
  },

  mutations: {
    SET_ACCOUNT_PURCHASE_LOADING: (state, loading) => {
      state.loading = loading;
    },
    SET_ACCOUNT_PURCHASE: (state, response) => {
      state.data = response;
      state.loading = false;
    },
    SET_ACCOUNT_PURCHASE_ERROR: (state, error) => {
      state.error = error;
      state.loading = false;
    },
  },

  actions: {
    LoadAccountPurchase({commit}, req) {
      commit('SET_ACCOUNT_PURCHASE_LOADING', true)
      commit('SET_ACCOUNT_PURCHASE_ERROR', null)
      return api.get(`accounts/${req.accountID}/purchases/${req.resourceID}`)
        .then((response) => {
          commit('SET_ACCOUNT_PURCHASE', response)
          commit('SET_ACCOUNT_PURCHASE_LOADING', false)
        })
        .catch((error) => {
          commit('SET_ACCOUNT_PURCHASE_ERROR', error)
          commit('SET_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
        })
    },
  },
}

export default account_purchase
